import { render, staticRenderFns } from "./timeTag.vue?vue&type=template&id=007b064b&scoped=true"
import script from "./timeTag.vue?vue&type=script&lang=js"
export * from "./timeTag.vue?vue&type=script&lang=js"
import style0 from "./timeTag.vue?vue&type=style&index=0&id=007b064b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b064b",
  null
  
)

export default component.exports